module.exports = __webpack_public_path__ + "img/menuimg7.f199b4cf.png";